import { render } from "./LockDeskQueue.vue?vue&type=template&id=5fa5e674&scoped=true"
import script from "./LockDeskQueue.vue?vue&type=script&lang=js"
export * from "./LockDeskQueue.vue?vue&type=script&lang=js"

import "./LockDeskQueue.vue?vue&type=style&index=0&id=5fa5e674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa5e674"]])

export default __exports__